/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getQuantileExperimentResultsOverrides';
import type { GetQuantileExperimentResultsQueryParams } from '../../operation-overrides/getQuantileExperimentResultsOverrides';

export type GetQuantileExperimentResultsPathParams = NonNullable<
  operations['getQuantileExperimentResults']['parameters']['path']
>;
export type { GetQuantileExperimentResultsQueryParams };

export interface Input extends GetQuantileExperimentResultsPathParams {
  apiVersion?: string;
  query?: GetQuantileExperimentResultsQueryParams;
}

export async function getQuantileExperimentResults(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/api/v2/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/metrics/{metricKey}/results/quantile',
    {
      params: {
        path,
        // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
        query,
      },
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      querySerializer: overrides.querySerializer,
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
